export default {
  NO_TRACKING: 'No Tracking',
  TRACKING_REQUESTED: 'Tracking Requested',
  TRACKING_ONGOING: 'Tracking Ongoing',
  TRACKING_ERROR: 'Tracking Request Error',
  TRACKING_COMPLETED: 'Tracking Completed',
  TRACKING_CANCELLED: 'Tracking cancelled',
  TRACKING_FAILED: 'Tracking failed',
};
